<script lang="ts">
	import type { BoutSummaryStats } from '../types';

	export let summary: BoutSummaryStats;
	export let corner: 'red' | 'blue';
</script>

<div class="column" class:spacer={corner === 'blue'}>
	<h4 class="{corner} text-center py-2 mb-0">Summary</h4>
	<table class="py-4">
		<thead />
		<tbody>
			<tr>
				<td colspan="4" class="pt-3">
					<strong>Total Punches</strong>
				</td>
			</tr>
			<tr>
				<td class="empty-column" />
				<td>Thrown</td>
				<td>{summary.punchesThrown}</td>
				<td />
			</tr>
			<tr>
				<td class="empty-column" />
				<td>Landed</td>
				<td>{summary.punchesLanded}</td>
				<td>{Math.round(summary.landedPercentage)} (%)</td>
			</tr>
			<tr>
				<td class="empty-column" />
				<td>Missed</td>
				<td>{summary.punchesMissed}</td>
				<td>{Math.round(summary.missedPercentage)} (%)</td>
			</tr>
			<tr class="bottom-row">
				<td colspan="2" class="pt-2">
					<strong> Total Knockdowns:</strong>
				</td>
				<td class="pt-2">{summary.knockdowns}</td>
				<td class="pt-2">{Math.round(summary.knockdownsPercentage)} (%)</td>
			</tr>
		</tbody>
	</table>
</div>

<style>
	.column {
		width: 37%;
	}

	table {
		background-color: white;
		width: 100%;
	}

	table .empty-column {
		width: 25%;
	}
	td {
		padding-right: 10px;
		padding-left: 10px;
	}

	.spacer {
		margin-right: 5%;
	}
	.blue {
		color: white;
		background-color: blue;
	}

	.red {
		background-color: red;
		color: white;
	}

	.bottom-row td {
		padding-bottom: 1rem;
	}

	@media (max-width: 576px) {
		.spacer {
			margin-right: 10px;
		}
		.column,
		.column {
			width: 50%;
		}

		table .empty-column {
			width: 10px;
		}

		td {
			padding-right: 0;
			padding-left: 0;
			font-size: 12px;
		}
	}
</style>
